/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import { Component } from 'react';
import PropTypes from 'prop-types';

export default class TabPanel extends Component {
	// never rendered
	static propTypes = {
		className: PropTypes.string,
		id: PropTypes.string.isRequired,
		label: PropTypes.string,
		subTitle: PropTypes.string,
		title: PropTypes.string,
		icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
		isIconBeforeLabel: PropTypes.bool,
		iconPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
		children: PropTypes.node,
		slideout: PropTypes.bool,
		keepTabContent: PropTypes.bool,
		resizable: PropTypes.bool,
		pinnable: PropTypes.bool,
		resizeMaxConstraintsX: PropTypes.number,
		resizeMinConstraintsX: PropTypes.number,
		resizeMaxConstraintsY: PropTypes.number,
		resizeMinConstraintsY: PropTypes.number,
		tooltipOrient: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
		width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // vertical tabs
	};

	static defaultProps = {
		resizable: false,
		pinnable: false,
		tooltipOrient: 'bottom',
	};
}
